// Detailed data for each service page

export const servicesData = {
  'gst-registration': {
    title: 'GST Registration',
    tagline: 'Get your GSTIN in 3–5 working days',
    hero: 'Simplify your GST registration with Register Point. From application to GSTIN issuance, our verified CAs handle everything end-to-end.',
    price: '₹1,499',
    priceNote: 'All inclusive',
    features: [
      'Application filing (GST REG-01)',
      'Document verification by expert CA',
      'ARN generation & tracking',
      'GSTIN certificate delivered on email',
      'Free consultation on HSN/SAC codes',
      'Post-registration compliance guidance',
    ],
    documents: [
      'PAN Card of business/proprietor',
      'Aadhaar Card',
      'Business address proof (rent agreement/electricity bill)',
      'Bank account details (cancelled cheque/passbook)',
      'Passport size photograph',
      'Digital signature (for companies/LLPs)',
    ],
    process: [
      { step: 'Consult', desc: 'Free 15-min call with a GST expert to review your needs.' },
      { step: 'Documents', desc: 'Upload your papers via a secure portal.' },
      { step: 'Filing', desc: 'Our CA files your GST REG-01 the same day.' },
      { step: 'GSTIN', desc: 'Receive your GSTIN certificate on email.' },
    ],
    faqs: [
      { q: 'Who needs GST registration?', a: 'Any business with turnover above ₹40 lakh (₹20 lakh for services), inter-state suppliers, e-commerce sellers, and voluntary registrants.' },
      { q: 'How long does it take?', a: 'Typically 3–5 working days after document submission and Aadhaar authentication.' },
      { q: 'Is physical verification needed?', a: 'Only in select cases where officer requests it; most applications are approved digitally.' },
    ],
  },
  'income-tax-return': {
    title: 'Income Tax Return Filing',
    tagline: 'File your ITR before the deadline—stress free',
    hero: 'ITR filing done right by Chartered Accountants. Salaried, business, capital gains or foreign income — we handle every ITR form.',
    price: '₹799',
    priceNote: 'Starting price',
    features: [
      'ITR-1 to ITR-7 filing',
      'Tax computation & optimisation',
      'Section 80C / 80D deductions maximised',
      'Capital gains reporting (equity, mutual funds, crypto)',
      'Foreign income & DTAA relief',
      'Response to IT notices included',
    ],
    documents: [
      'PAN & Aadhaar',
      'Form 16 / salary slips',
      'Form 26AS & AIS',
      'Bank statements',
      'Investment proofs (LIC, PPF, ELSS, etc.)',
      'Capital gains statement (if applicable)',
    ],
    process: [
      { step: 'Upload', desc: 'Share your documents securely.' },
      { step: 'Review', desc: 'Our CA computes tax & shares a draft.' },
      { step: 'Approve', desc: 'You approve, we e-verify.' },
      { step: 'Done', desc: 'ITR acknowledgement delivered.' },
    ],
    faqs: [
      { q: 'What is the ITR filing due date?', a: 'For most individuals, 31st July of the assessment year. For audit cases, 31st October.' },
      { q: 'Do I need to file if my income is below ₹5 lakh?', a: 'You may still need to file if you have foreign assets, TDS, or want a refund. Consult our CA free.' },
      { q: 'What if I get an IT notice?', a: 'We handle notice responses at no extra cost for our filed returns.' },
    ],
  },
  'company-registration': {
    title: 'Company Registration',
    tagline: 'Register your Pvt Ltd company in 7–10 days',
    hero: 'Turn your idea into a legal entity. Register Point handles name approval, DSC, DIN, MOA, AOA and incorporation — all online.',
    price: '₹6,999',
    priceNote: 'Govt. fees extra',
    features: [
      'Name reservation (RUN)',
      '2 Digital Signature Certificates',
      '2 Director Identification Numbers',
      'MOA & AOA drafting',
      'Certificate of Incorporation',
      'PAN & TAN allotment',
      'Bank account opening support',
    ],
    documents: [
      'PAN & Aadhaar of directors',
      'Passport size photos',
      'Address proof of directors',
      'Registered office address proof',
      'NOC from property owner',
      'Utility bill (not older than 2 months)',
    ],
    process: [
      { step: 'Name', desc: 'Reserve a unique company name.' },
      { step: 'DSC & DIN', desc: 'Directors get digital identity.' },
      { step: 'SPICe+', desc: 'File incorporation form.' },
      { step: 'Certificate', desc: 'Get your Certificate of Incorporation.' },
    ],
    faqs: [
      { q: 'Minimum directors and shareholders?', a: 'A Private Limited Company requires minimum 2 directors and 2 shareholders (can be the same people).' },
      { q: 'Is there a minimum paid-up capital?', a: 'No minimum since Companies Amendment Act 2015.' },
      { q: 'Can NRIs register a company in India?', a: 'Yes, at least one director must be Indian resident.' },
    ],
  },
  'trademark-registration': {
    title: 'Trademark Registration',
    tagline: 'Protect your brand for 10 years',
    hero: 'Register your brand name, logo or slogan and get pan-India protection. Our trademark attorneys handle search, filing and objection response.',
    price: '₹6,499',
    priceNote: 'Govt. fees extra',
    features: [
      'Trademark search & availability check',
      'Class identification',
      'TM application filing',
      'TM mark usage right (™) immediately',
      'Objection & opposition handling',
      'Registration certificate (®)',
    ],
    documents: [
      'Applicant details (individual/company)',
      'Logo/wordmark in JPG',
      'Description of goods/services',
      'User affidavit (if used before)',
      'MSME certificate (for discounted fees)',
      'Power of attorney',
    ],
    process: [
      { step: 'Search', desc: 'Comprehensive trademark search.' },
      { step: 'File', desc: 'File application in relevant class.' },
      { step: 'Examination', desc: 'Respond to any objections.' },
      { step: 'Registered', desc: 'Receive registration certificate.' },
    ],
    faqs: [
      { q: 'How long is a trademark valid?', a: '10 years from date of application, renewable indefinitely.' },
      { q: 'Can I use TM immediately after filing?', a: 'Yes, you can use ™ right after filing. Use ® only after registration.' },
      { q: 'What is trademark class?', a: 'There are 45 classes covering different goods and services. Choose the class matching your business.' },
    ],
  },
  'bookkeeping': {
    title: 'Bookkeeping & Accounting',
    tagline: 'Focus on business — we handle the books',
    hero: 'Monthly bookkeeping, ledger maintenance, financial reports and GST reconciliation by experienced accountants. Zero-error, on-time.',
    price: '₹2,999/mo',
    priceNote: 'Starting price',
    features: [
      'Daily transaction entry',
      'Bank & credit card reconciliation',
      'Accounts payable & receivable',
      'Monthly P&L and balance sheet',
      'GST-ready books',
      'Cloud accounting (Zoho/Tally/QuickBooks)',
    ],
    documents: [
      'Bank statements',
      'Sales & purchase invoices',
      'Expense receipts',
      'GST returns filed',
      'Payroll data',
      'Existing books (if any)',
    ],
    process: [
      { step: 'Onboard', desc: 'Setup software & chart of accounts.' },
      { step: 'Collect', desc: 'Share monthly transactions.' },
      { step: 'Record', desc: 'We enter & reconcile.' },
      { step: 'Report', desc: 'Monthly reports delivered.' },
    ],
    faqs: [
      { q: 'Which software do you use?', a: 'Your choice — Tally, Zoho Books, QuickBooks, or Xero. We adapt to your workflow.' },
      { q: 'Is my data safe?', a: 'Yes, all data is encrypted and shared via secure portals. NDA available.' },
      { q: 'Can you clean up old books?', a: 'Absolutely. We offer catch-up bookkeeping for backlogged periods.' },
    ],
  },
  'fdi-compliance': {
    title: 'FDI Compliance',
    tagline: 'Attract foreign investment the right way',
    hero: 'Comprehensive FDI advisory covering RBI filings, FC-GPR, FC-TRS, annual returns and sector-wise compliance.',
    price: '₹9,999',
    priceNote: 'Starting price',
    features: [
      'FDI structuring advisory',
      'FC-GPR filing (share allotment)',
      'FC-TRS filing (share transfer)',
      'FLA return filing',
      'Sector-wise cap advisory',
      'RBI approval routes',
    ],
    documents: [
      'Foreign remittance advice',
      'FIRC / KYC of investor',
      'Board resolution',
      'Valuation certificate',
      'Share allotment details',
      'Company incorporation docs',
    ],
    process: [
      { step: 'Advisory', desc: 'Structure & sector-cap review.' },
      { step: 'Documentation', desc: 'Prepare all required forms.' },
      { step: 'RBI Filing', desc: 'File within statutory deadlines.' },
      { step: 'Confirmation', desc: 'Get RBI acknowledgement.' },
    ],
    faqs: [
      { q: 'What is the timeline for FC-GPR?', a: 'Within 30 days of share allotment to foreign investor.' },
      { q: 'Which sectors have FDI caps?', a: 'Defence, telecom, insurance, print media and a few others. We advise on the current caps.' },
      { q: 'Automatic vs approval route?', a: 'Most sectors are under automatic route. Some require prior government approval.' },
    ],
  },
  'annual-filing': {
    title: 'Company Annual Filing',
    tagline: 'ROC compliance, done on time',
    hero: 'AOC-4, MGT-7, DIR-3 KYC and all other MCA filings handled by expert Company Secretaries.',
    price: '₹4,999',
    priceNote: 'Starting price',
    features: [
      'AOC-4 (financial statements)',
      'MGT-7 (annual return)',
      'DIR-3 KYC of directors',
      'DPT-3 (return of deposits)',
      'Board meeting minutes drafting',
      'AGM compliance support',
    ],
    documents: [
      'Audited financial statements',
      'Directors’ report',
      'Board resolutions',
      'Shareholding pattern',
      'DSC of directors',
      'Previous year filings',
    ],
    process: [
      { step: 'Review', desc: 'Verify audited financials.' },
      { step: 'Prepare', desc: 'Draft AOC-4 & MGT-7.' },
      { step: 'File', desc: 'Submit on MCA portal.' },
      { step: 'Acknowledge', desc: 'Receive filing confirmation.' },
    ],
    faqs: [
      { q: 'Due date for AOC-4?', a: '30 days from AGM. AGM must be held within 6 months of FY end.' },
      { q: 'Penalty for late filing?', a: '₹100 per day per form, no upper limit. File on time to avoid.' },
      { q: 'Is DIR-3 KYC needed every year?', a: 'Yes, every director must complete DIR-3 KYC annually by 30 September.' },
    ],
  },
  'fssai-registration': {
    title: 'FSSAI Registration',
    tagline: 'Food business licence in 7–15 days',
    hero: 'Basic, State or Central FSSAI registration — whichever your food business needs, we handle end-to-end.',
    price: '₹1,999',
    priceNote: 'Govt. fees extra',
    features: [
      'Category assessment (Basic/State/Central)',
      'Application filing',
      'Document scrutiny',
      'Inspection coordination',
      'FSSAI licence delivery',
      'Renewal reminders',
    ],
    documents: [
      'PAN & Aadhaar',
      'Business address proof',
      'Photo ID of proprietor/directors',
      'Food safety plan',
      'Product list',
      'NOC from municipality (if applicable)',
    ],
    process: [
      { step: 'Assess', desc: 'Choose the right licence type.' },
      { step: 'Apply', desc: 'File Form A or Form B.' },
      { step: 'Verify', desc: 'Coordinate with FSSAI officer.' },
      { step: 'Licence', desc: 'Receive your FSSAI number.' },
    ],
    faqs: [
      { q: 'Which licence do I need?', a: 'Basic: turnover < ₹12 lakh. State: ₹12 lakh–₹20 crore. Central: > ₹20 crore or import/export.' },
      { q: 'Validity of FSSAI licence?', a: '1 to 5 years, your choice at application.' },
      { q: 'Is display of FSSAI number mandatory?', a: 'Yes, on all packaging, invoices and premises.' },
    ],
  },
};

export const serviceSlugs = Object.keys(servicesData);

export const blogPosts = [
  {
    slug: 'chartered-accountant',
    title: 'Talk to a Chartered Accountant (CA)',
    date: '15 July 2025',
    category: 'CA Services',
    excerpt: 'A step-by-step guide to consulting a CA online and getting your tax, GST and compliance queries resolved.',
    body: [
      'Hiring a Chartered Accountant used to mean visiting an office, waiting in queues and lengthy paperwork. Today, with online CA marketplaces like Register Point, you can consult a verified CA in minutes — from anywhere in India.',
      'A qualified CA can help with tax planning, GST filing, company registration, audit, financial reporting and much more. The right CA can save you significant tax rupees and help avoid compliance penalties.',
      'Look for a CA with experience in your industry, transparent pricing, and strong communication. At Register Point, every CA is verified for credentials, experience and client feedback.',
    ],
  },
  {
    slug: 'online-ca-consultancy',
    title: 'Get Online CA Consulting Services in India',
    date: '10 July 2025',
    category: 'Consultancy',
    excerpt: 'Everything you need to know about hiring an online CA for your business or personal taxation.',
    body: [
      'Online CA consultancy has revolutionised how Indian businesses handle compliance. What used to take weeks now takes days. What required multiple in-person visits now happens over video calls.',
      'The advantages are clear: lower cost, faster turnaround, access to top-tier CAs regardless of location, and digital audit trails for every transaction. Small businesses especially benefit from this model.',
      'Register Point brings together 5000+ verified professionals covering every specialisation — taxation, audit, company law, FDI, international taxation and more.',
    ],
  },
  {
    slug: 'popular-ca-platforms',
    title: 'Popular Chartered Accountants Service Platforms in India',
    date: '02 July 2025',
    category: 'Industry',
    excerpt: 'A curated look at leading online CA service marketplaces and what makes each stand out.',
    body: [
      'The Indian CA services market has seen many platforms emerge in recent years. Each has its own strengths — some focus on startups, others on tax filing, some on comprehensive compliance.',
      'Register Point differentiates itself with a strict CA verification process, transparent pricing, service-level guarantees and a broad service catalogue covering 60+ compliance areas.',
      'When choosing a platform, look for verified professionals, transparent pricing, response times, and client reviews. And ideally, one that offers post-service support.',
    ],
  },
];
